import React, { useContext, useEffect, useState } from "react";
import global_context from "../../../../static_vars";
import dayjs, { Dayjs } from "dayjs";
import { Grid, Grow, Stack, Typography } from "@mui/material";
import DatePicker from "../../../../components/selectors/Shared/DateSelect";
import RoleSelect from "../../../../components/selectors/RoleSelect";
import ServerSelect from "../../../../components/selectors/ServerSelect";
import SoloQPlayerRankingGrid from "../../../../components/datagrids/SoloQ/SoloQPlayerRankingGrid";
import SoloQAccountSelect from "../../../../components/selectors/SoloQAccountSelect";
import PlayerMatchHistory from "../../../../components/datagrids/Competitive/PlayerHistory";
import PlayerChampions from "../../../../components/datagrids/Competitive/PlayerChampions";
import SoloQPlayerMatchHistory from "../../../../components/datagrids/SoloQ/SoloQPlayerHistory";
import SoloQPlayerChampions from "../../../../components/datagrids/SoloQ/SoloQPlayerChampions";
import FarsightApi from "../../../../ApiWrapper";
import StatRow from "../../../../components/visu_blocks/StatRow";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import WindowContainer from "../../../../components/layout/WindowContainer";

export default function SoloQPlayerDetails() {
    const context = useContext(global_context);
    const { current_role, current_champions, current_account, current_server } = context.state;
    const [state, setState] = useState({
        player: current_account,
        from: dayjs("2023-01-01"),
        until: dayjs(),
        role: current_role,
        champions: current_champions,
        server: ["EUW", "KR"],
    });

    const handleFromChange = (newValue: Dayjs) => {
        setState({ ...state, from: newValue });
        context.state.current_competitive_from = newValue;
    };
    const handleUntilChange = (newValue: Dayjs) => {
        setState({ ...state, until: newValue });
        context.state.current_competitive_until = newValue;
    };
    const handleRoleChange = (event: any) => {
        setState({ ...state, role: event.target.value });
        context.state.current_role = event.target.value;
    };
    const handleAccountChange = (event: any, newValue: any) => {
        console.log(event);
        if (newValue) {
            setState({ ...state, player: newValue });
            context.state.current_account = newValue;
        } else {
            setState({ ...state, player: { name: "", id: "" } });
        }
    };
    const handleChampionsChange = (event: any, newValue: any) => {
        setState({ ...state, champions: newValue });
    };

    return (
        <WindowContainer direction={"column"} spacing={2}>
            <Grid container direction={"row"} alignItems={"space-evenly"} justifyContent={"flex-start"} alignSelf={"space-evenly"} spacing={5}>
                <DatePicker onChange={handleFromChange} value={state.from} label={"Games From"} />
                <DatePicker onChange={handleUntilChange} value={state.until} label={"Games Until"} />
                <RoleSelect value={state.role} onChange={handleRoleChange} />
                <SoloQAccountSelect onChange={handleAccountChange} value={state.player} from={state.from} until={state.until} server={state.server} role={state.role} />
                {/*<MultipleChampionSelect getValue={state.champions} onChange={handleChampionsChange}/>*/}
            </Grid>
            <Stack direction="row" sx={{ height: "100%", justifyContent: "center", width: "100%" }}>
                <SoloQPlayerMatchHistory from={state.from} server={state.server} until={state.until} account={state.player.id} role={state.role} champions={state.champions} />
                <SoloQPlayerChampions from={state.from} server={state.server} until={state.until} account={state.player.id} role={state.role} champions={state.champions} />
            </Stack>
        </WindowContainer>
    );
}

export function SoloQPlayerStats(props: any) {
    const [data, setData] = useState(undefined as any);
    const [reload, setReload] = useState(true);
    let props_copy: any = JSON.parse(JSON.stringify(props));
    props_copy.metrics = ["games", "winrate", "kda", "cspm", "performance", "relative_performance", "gd15", "xpd15", "csd15", "dpm", "gpm"];
    props_copy.groupby = "account__player";

    useEffect(() => {
        setReload(false);
        setData(undefined);
        FarsightApi.get_request("StatsOverview", props_copy)
            .then((r) => {
                setData(r);
            })
            .then(() => setReload(true));
    }, [props.player]);
    return data && data.account__player ? (
        <Stack
            direction={"column"}
            sx={{
                height: "100%",
                justifyContent: "space-evenly",
                alignItems: "center",
                display: "flex",
                width: "230px",
                borderRadius: 3,
            }}
            spacing={2}
        >
            <Stack direction={"column"} sx={{ width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 2000 }}>
                    <Button
                        variant={"outlined"}
                        sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            borderRadius: 3,
                        }}
                        onClick={() =>
                            navigator.clipboard.writeText(
                                `${Math.round(data["performance"] * 100) / 100}\t${Math.round(data["relative_performance"] * 100) / 100}\t${data["games"]}\t${data["winrate"].toLocaleString("en", {
                                    style: "percent",
                                })}`.replaceAll(".", ","),
                            )
                        }
                    >
                        {"SoloQ Stats"}
                    </Button>
                </Grow>
                <StatRow stat={"Nb. Games"} value={data["games"]} />
                <StatRow
                    stat={"WR"}
                    value={data["winrate"].toLocaleString("en", {
                        style: "percent",
                    })}
                />
                <StatRow stat={"Perf."} value={Math.round(data["performance"] * 100) / 100} />
                <StatRow stat={"RPerf."} value={Math.round(data["relative_performance"] * 100) / 100} />
            </Stack>
            <Stack direction={"column"} sx={{ width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 3000 }}>
                    <Typography
                        sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            borderRadius: 3,
                            outline: "1px solid white",
                        }}
                    >
                        {"In Game"}
                    </Typography>
                </Grow>
                <StatRow stat={"KDA"} value={Math.round(data["kda"] * 100) / 100} />
                <StatRow stat={"DPM"} value={Math.round(data["dpm"] * 100) / 100} />
                <StatRow stat={"CSPM"} value={Math.round(data["cspm"] * 100) / 100} />
                <StatRow stat={"GPM"} value={Math.round(data["gpm"] * 100) / 100} />
            </Stack>
            <Stack direction={"column"} sx={{ width: "100%" }}>
                <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 4000 }}>
                    <Typography
                        sx={{
                            width: "100%",
                            justifyContent: "center",
                            display: "flex",
                            borderRadius: 3,
                            outline: "1px solid white",
                        }}
                    >
                        {"Laning"}
                    </Typography>
                </Grow>
                <StatRow stat={"GD@15"} value={Math.round(data["gd15"] * 100) / 100} />
                <StatRow stat={"XPD@15"} value={Math.round(data["xpd15"] * 100) / 100} />
                <StatRow stat={"CSD@15"} value={Math.round(data["csd15"] * 100) / 100} />
            </Stack>
        </Stack>
    ) : (
        <Box sx={{ width: "230px", textJustify: "center", textAlign: "center" }}>{`No ${props.player} games for selected preset`}</Box>
    );
}
